import { Role, Roles } from '../models/user.model';
import type { InvoiceSearchEvent } from './invoice.service';

export interface InvoiceSearchPreferences {
  searchData: InvoiceSearchEvent;
}

export const InvoicePreferenceKeys = {
  tableState: (userId: number): string => `invoice_table_state_${userId}`,
  pageSize: (userId: number): string => `invoice_table_component_size_${userId}`,
  filterLayout: (userId: number): string => `invoices_${userId}_filter_state`,
  search: (userId: number): string => `invoices_${userId}_search_state`,
  autoGenerated: (userId: number): string => `invoices_${userId}_auto_generated_filter`,
};

export function normalizeInvoiceSearchEventForRole(searchData: InvoiceSearchEvent, role: Roles): InvoiceSearchEvent {
  const normalizedSearchData: InvoiceSearchEvent = {
    ...searchData,
    paymentTypes: [...(searchData.paymentTypes || [])],
    statuses: [...(searchData.statuses || [])],
    packageNames: [...(searchData.packageNames || [])],
    companyNames: [...(searchData.companyNames || [])],
    userIds: [...(searchData.userIds || [])],
    createdByUserIds: [...(searchData.createdByUserIds || [])],
    convertedByUserIds: [...(searchData.convertedByUserIds || [])],
  };

  if (role !== Role.ADMIN) {
    normalizedSearchData.paymentTypes = [];
    normalizedSearchData.companyNames = [];
    normalizedSearchData.userIds = [];
    normalizedSearchData.convertedByUserIds = [];
  }

  return normalizedSearchData;
}
